import Language from "orbiter-core/src/datastructures/languages/Language";
import MultiLanguageString from "orbiter-core/src/datastructures/languages/MultiLanguageString";
import SingleLanguageString from "orbiter-core/src/datastructures/languages/SingleLanguageString";
import ApiController from "../ApiController";
import {
    IHandrailHandle,
    default as HandrailHandle
} from "../../../../../shared/datastructures/staircasedata/HandrailHandle";

// TODO: too much code duplication
export default class HandrailHandleAPI extends ApiController<HandrailHandle> implements IHandrailHandle {

    public static getBaseEndpoint(): string{
        return "hotec/handrailhandle";
    }

    public static getApiKey(): string{
        return "handrailHandle";
    }

    public async parseFromDictionary(dictionary): Promise<void> {

        const title = new MultiLanguageString(
            dictionary.title.map((x) => {
                // TODO: LanguageAPI?
                const l = new Language(
                    x.languageId,
                    null,
                    null,
                );
                return new SingleLanguageString(
                    l,
                    x.value,
                );
            }),
        );

        const desc = new MultiLanguageString(
            dictionary.description.map((x) => {
                // TODO: LanguageAPI?
                const l = new Language(
                    x.languageId,
                    null,
                    null,
                );
                return new SingleLanguageString(
                    l,
                    x.value,
                );
            }),
        );

        const handrailHandle = new HandrailHandle(
            title,
            desc,
            dictionary.imagePreviewIds,
        );
        this.setData(handrailHandle);
    }

    public getDescription(): MultiLanguageString {
        return this.getData().getDescription();
    }

    public async setDescription(newDescription: MultiLanguageString): Promise<void> {
        this.getData().setDescription(newDescription);
        await this.updateProperty("description", newDescription);
    }

    public async setTitle(newTitle: MultiLanguageString): Promise<void> {
        this.getData().setTitle(newTitle);
        await this.updateProperty("title", newTitle);
    }

    public getTitle(): MultiLanguageString {
        return this.getData().getTitle();
    }

    public getImagePreviewIds(): string[] {
        return this.getData().getImagePreviewIds();
    }
    
    public async setImagePreviewIds(newImagePreviewIds: string[]): Promise<void> {
        this.getData().setImagePreviewIds(newImagePreviewIds);
        await this.updateProperty("imagePreviewIds", newImagePreviewIds);
    }

}
